/**
 * Returns array of title and id without #
 * @param {Object} params
 * @param {string} params.type
 * @param {string} params.title
 * @param {string} params.slug - requires for 'block' type
 * @returns {string[]} Array contains anchorTitle and anchorId
 * 
 */
import i18n from '@/lib/i18n';

export default function generateAnchorsParams({ type, title, slug }) {
  let anchorTitle
  let anchorId
  const t = (key) => i18n.t(key, { ns: 'global' });

  switch (type) {
    case 'certificates':
      anchorTitle = title || t('services.certificatesTitle')
      anchorId = 'certificates'
      break
    case 'pricelist':
      anchorTitle = title || t('services.pricelistTitle')
      anchorId = 'pricelist'
      break
    case 'reviews':
      anchorTitle = title || t('services.reviewsTitle')
      anchorId = 'reviews'
      break
    case 'questions':
      anchorTitle = title || t('services.questionsTitle')
      anchorId = 'questions'
      break
    case 'services':
      anchorTitle = title || t('services.servicesTitle')
      anchorId = 'services'
      break
    case 'specialists':
      anchorTitle = title || t('services.specialistsTitle')
      anchorId = 'specialists'
      break
    case 'portfolio':
      anchorTitle = title || t('services.portfolioTitle')
      anchorId = 'portfolio'
      break
    case 'subdirections':
      anchorTitle = title || t('services.subdirectionsTitle')
      anchorId = 'subdirections'
      break
    case 'encyclopedia':
      anchorTitle = title || t('services.encyclopediaTitle')
      anchorId = 'encyclopedia'
      break
    case 'recommendations':
      anchorTitle = title || t('services.recommendationsTitle')
      anchorId = 'recommendations'
      break
    case 'block':
    default:
      anchorTitle = title
      anchorId = slug
  }

  return [anchorTitle, anchorId]
}
